import CommonPage from '@/components/commonPage/index.vue'
import CommonPagination from "@/components/commonPage/components/tableComp/CommonPagination.vue"

import FormSelectItem from "@/components/commonPage/components/tableComp/formItems/FormSelectItem.vue"
import FormGroupSearchItem from "@/components/commonPage/components/tableComp/formItems/FormGroupSearchItem.vue"
import FormDateItem from "@/components/commonPage/components/tableComp/formItems/FormDateItem.vue"
import FormTimeItem from "@/components/commonPage/components/tableComp/formItems/FormTimeItem.vue"
import FormDatetimeItem from "@/components/commonPage/components/tableComp/formItems/FormDatetimeItem.vue"
import FormTextItem from "@/components/commonPage/components/tableComp/formItems/FormTextItem.vue"
import FormPopupItem from "@/components/commonPage/components/tableComp/formItems/FormPopupItem.vue"
import FormGroupSelectItem from "@/components/commonPage/components/tableComp/formItems/FormGroupSelectItem.vue"
import FormImageItem from "@/components/commonPage/components/tableComp/formItems/FormImageItem.vue"
import FormNumberItem from "@/components/commonPage/components/tableComp/formItems/FormNumberItem.vue"
import FormVideoItem from "@/components/commonPage/components/tableComp/formItems/FormVideoItem.vue"

import TableImageItem from "@/components/commonPage/components/tableComp/tableItems/TableImageItem.vue"
import TableNumberItem from "@/components/commonPage/components/tableComp/tableItems/TableNumberItem.vue"
import TableDatetimeItem from "@/components/commonPage/components/tableComp/tableItems/TableDatetimeItem.vue"
import TableEditorItem from "@/components/commonPage/components/tableComp/tableItems/TableEditorItem.vue"
import TableGroupItem from "@/components/commonPage/components/tableComp/tableItems/TableGroupItem.vue"
import TableSelectItem from "@/components/commonPage/components/tableComp/tableItems/TableSelectItem.vue"
import TableTextItem from "@/components/commonPage/components/tableComp/tableItems/TableTextItem.vue"
import TableTimeItem from "@/components/commonPage/components/tableComp/tableItems/TableTimeItem.vue"
import TableVideoItem from "@/components/commonPage/components/tableComp/tableItems/TableVideoItem.vue"
import TablePopupItem from "@/components/commonPage/components/tableComp/tableItems/TablePopupItem.vue"
import TablePopup2Item from "@/components/commonPage/components/tableComp/tableItems/TablePopup2Item.vue"
import TablePopupDtableItem from "@/components/commonPage/components/tableComp/tableItems/TablePopupDtableItem.vue"

export default {
  components: {
    CommonPage,
    CommonPagination,
    FormSelectItem,
    FormGroupSearchItem,
    FormDateItem,
    FormTimeItem,
    FormDatetimeItem,
    FormTextItem,
    TableImageItem,
    TableNumberItem,
    TableDatetimeItem,
    TableEditorItem,
    TableGroupItem,
    TableSelectItem,
    TableTextItem,
    TableTimeItem,
    TableVideoItem,
    FormPopupItem,
    FormGroupSelectItem,
    FormImageItem,
    FormNumberItem,
    FormVideoItem,
    TablePopupItem,
    TablePopup2Item,
    TablePopupDtableItem
  }
}
